import styled from '@emotion/styled';
import {
  Button,
  Divider,
  Drawer,
  DrawerBody,
  DrawerHeader,
  IconButton,
  MenuList,
  Typography,
  blue,
  orange,
  tokens,
} from '@galaxy-react/core';

export const StyledMenuList = styled(MenuList)({
  '&.fui-MenuList': {
    rowGap: 4,
    padding: '2px 5px',
  },
});

export const StyledMenuListNoPad = styled(MenuList)({
  '&.fui-MenuList': {
    rowGap: 4,
    padding: 0,
  },
});

export const StyledDrawer = styled(Drawer)({
  '&.fui-Drawer': {
    width: 1184,
    borderRadius: `${tokens.spacingHorizontalNone} ${tokens.borderRadiusXLarge} ${tokens.borderRadiusXLarge} ${tokens.spacingHorizontalNone}`,
    boxShadow: '0px 8px 16px 0px rgba(0, 0, 0, 0.14)',
    backdropFilter: 'blur(30px)',
    backgroundColor: 'rgba(249, 250, 251, 0.95)',
  },
});

export const StyledDrawerBody = styled(DrawerBody)({
  '&.fui-DrawerBody': {
    paddingTop: 0,
    paddingBottom: tokens.spacingVerticalXXL,
    paddingLeft: 22, //fisrt grid column has extra 2px
    paddingRight: 24,
    margin: 0,
    backgroundSize: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'bottom',
    backgroundImage: `url("data:image/svg+xml,%3Csvg width='1184' height='148' viewBox='0 0 1184 148' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_2250_26287)' filter='url(%23filter0_i_2250_26287)'%3E%3Cpath d='M850.008 197.36L1183.94 77.4803V0L-134.736 197.36H850.008Z' fill='url(%23paint0_linear_2250_26287)'/%3E%3Cmask id='mask0_2250_26287' style='mask-type:alpha' maskUnits='userSpaceOnUse' x='-135' y='0' width='1319' height='198'%3E%3Cpath d='M850.069 197.36L1184 77.4803V0L-134.674 197.36H850.069Z' fill='url(%23paint1_linear_2250_26287)'/%3E%3C/mask%3E%3Cg mask='url(%23mask0_2250_26287)'%3E%3Cg filter='url(%23filter1_d_2250_26287)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M1081.76 177.352L749.181 296.72L902.918 591.441L1792.28 1006.85L1137.08 333.208L1081.76 177.352ZM899.363 -335.96L136.612 13.5591L242.717 898.167L356.908 285.899L1081.76 177.352L899.363 -335.96Z' fill='%231E365E'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_i_2250_26287' x='0' y='-7.4' width='1185.48' height='155.4' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3E%3CfeOffset dx='1.48' dy='-7.4'/%3E%3CfeGaussianBlur stdDeviation='37'/%3E%3CfeComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0'/%3E%3CfeBlend mode='normal' in2='shape' result='effect1_innerShadow_2250_26287'/%3E%3C/filter%3E%3Cfilter id='filter1_d_2250_26287' x='112.932' y='-365.56' width='1714.87' height='1402.01' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3E%3CfeOffset dx='5.92'/%3E%3CfeGaussianBlur stdDeviation='14.8'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0'/%3E%3CfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_2250_26287'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_2250_26287' result='shape'/%3E%3C/filter%3E%3ClinearGradient id='paint0_linear_2250_26287' x1='972.951' y1='11.8416' x2='937.894' y2='292.262' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%2312284E'/%3E%3Cstop offset='0.5' stop-color='%231E365E'/%3E%3Cstop offset='1' stop-color='%2336507C'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint1_linear_2250_26287' x1='252.17' y1='11.8544' x2='266.896' y2='174.967' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%231E365E'/%3E%3Cstop offset='1' stop-color='%23182B4B'/%3E%3C/linearGradient%3E%3CclipPath id='clip0_2250_26287'%3E%3Crect width='1184' height='148' fill='white' transform='matrix(-1 0 0 1 1184 0)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A")`,
  },
});

export const StyledDrawerHeader = styled(DrawerHeader)({
  '&.fui-DrawerHeader': {
    paddingBottom: 14,
  },
});

export const StyledTitle = styled(Typography)({
  color: orange[600],
  marginLeft: tokens.spacingHorizontalM,
});

export const StyledSubtitle = styled(Typography)({
  color: blue[700],
  marginBottom: tokens.spacingVerticalXXS,
  paddingLeft: 11,
  paddingRight: tokens.spacingHorizontalXXS,
});

export const StyledDivider = styled(Divider)({
  //the total spacing will be 16px  combined with the MenuList padding
  margin: `14px ${tokens.spacingHorizontalXXS} 14px 11px`,
  '&.fui-Divider': {
    width: 'auto',
  },
  '&.fui-Divider::before': {
    borderColor: '#A4A5A8',
    borderWidth: tokens.strokeWidthThin,
  },
  '&.fui-Divider::after': {
    borderColor: '#A4A5A8',
    borderWidth: tokens.strokeWidthThin,
  },
});

export const StyledMenuGrid = styled('div')({
  display: 'flex',
  //second column larger to fit scrollbar
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: 20,
});

export const StyledMenu = styled('div')({
  flexBasis: '300px',
  flexShrink: 0,
});

export const StyledSubmenu = styled('div')({
  maxHeight: 'calc(100vh  - 180px)',
  overflowY: 'auto',
  paddingRight: tokens.spacingHorizontalXXL,
  flex: '1 0 360px',
});

export const StyledIconButton = styled(IconButton)({
  '&&.fui-Button': {
    padding: 4,
    backgroundColor: tokens.colorBrandForeground1,
    '&:hover': {
      backgroundColor: tokens.colorBrandBackgroundHover,
    },
    '&:active, &:focus-visible': {
      border: ' 1px solid',
      borderColor: `${tokens.colorNeutralBackground4Hover} !important`,
      //Note: !important overrides element.style
      boxShadow: '0px 0px 0px 0.5px #FFFFFF, 0px 0px 0px 2px #444444, inset 0px 0px 0px 1px rgba(255, 255,255, 0.1)',
    },
  },
  '&& .fui-Button__icon': {
    width: 24,
    height: 24,
  },
});

export const StyledSubSubmenu = styled('div')({
  padding: `${tokens.spacingHorizontalM} ${tokens.spacingHorizontalL}`,
  borderRadius: tokens.borderRadiusMedium,
  // Note: Colour in Figma is rgba(249, 250, 251, 0.95) but it doesn't replicate the design as it's the same colour as the Drawer background
  backgroundColor: 'rgba(255, 255, 255, 0.95)',
  height: 'calc(100vh - 98px)',
});

export const ActionButton = styled(Button)({
  '&.fui-Button': {
    minWidth: '100%',
    marginTop: 14,
  },
});

export const ActionButtonWrapper = styled('div')({
  padding: 2,
});
